<template>
  <el-row class="page-content">
    <el-col :span="24">
      <ScrollingVideoList
        :title="activityName ? $t('videosByActivity.title', { activity: activityName }) : ''"
        :showGoBackButton="goBackButtonIsShown"
        :showVideos="showVideos"
        :videos="videos"
        @on-infinite-scroll-trigger="infiniteHandler"
      />
    </el-col>
  </el-row>
</template>

<script>
import { infiniteVideoListScrolled } from '@/useCases/videoGallery.usecase.js';
import { mapState } from 'vuex';
import ScrollingVideoList from './components/ScrollingVideoList.vue';

export default {
  name: 'VideosByActivity',

  components: {
    ScrollingVideoList
  },

  mounted () {
    this.videosByActivityPageOpened({
      showGoBackButton: this.showGoBackButton,
      showVideosByActivityAsInfiniteScroll: this.showVideosByActivity
    });
    window.scroll(0, 0);
  },

  data () {
    return {
      selectedActivity: parseInt(this.$router.currentRoute.value.params?.id),
      goBackButtonIsShown: false,
      showVideos: false,
      videos: [],
      page: 1
    };
  },

  computed: {
    ...mapState('zone', ['activities']),
    activityName () {
      const firstVideo = this.videos[0];
      return firstVideo?.activity?.name || '';
    }
  },

  methods: {
    videosByActivityPageOpened ({ showGoBackButton, showVideosByActivityAsInfiniteScroll }) {
      showGoBackButton();
      showVideosByActivityAsInfiniteScroll();
    },
    showGoBackButton () {
      this.goBackButtonIsShown = true;
    },
    async showVideosByActivity () {
      this.showVideos = true;
    },
    infiniteHandler ($state) {
      infiniteVideoListScrolled({
        getMoreVideos: this.$services.HTTP.videos.getVideosByActivity,
        extractData: this.extractData,
        filters: { activityFilter: [this.selectedActivity], pageFilter: this.page },
        continueInfiniteScroll: this.continueInfiniteScroll($state),
        stopInfiniteScroll: this.stopInfiniteScroll($state),
        handleError: this.handleVideosByActivityLoadingError
      });
    },
    continueInfiniteScroll ($state) {
      return newData => {
        this.page += 1;
        this.videos.push(...newData);
        $state.loaded();
      };
    },
    stopInfiniteScroll ($state) {
      return () => {
        $state.complete();
      };
    },
    extractData ({ data }) {
      return data.rows;
    },
    handleVideosByActivityLoadingError (error) {
      this.$information.capture({ error });
      this.$information.alert({
        message: this.$t('calendar.errors.GENERAL_ERROR')
      });
    }
  }
};
</script>

<style lang="less">
</style>
